import http from './http'

export default {
  getForm: draftId => http.get(`/v2/drafts/${draftId}/biosecurity`),
  createForm: (draftId, data) => http.post(`/v2/drafts/${draftId}/biosecurity`, data, { silent: true }),
  updateForm: (draftId, data) => http.patch(`/v2/drafts/${draftId}/biosecurity`, data, { silent: true }),
  getBlankPdf: () => http.get('/v2/nominations/biosecurity-blank-form', { responseType: 'blob' }),
  downloadReport: (draftId, format) => http.get(`/v2/drafts/${draftId}/biosecurity/report`, { params: { format }, responseType: 'blob' })
}



// WEBPACK FOOTER //
// ./src/services/api/biosecurity.js